var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaneslogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    viewBox: "0 0 512 376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_3-2);\n      }\n\n      .cls-2 {\n        fill: url(#_\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_11);\n      }\n\n      .cls-3 {\n        fill: url(#_\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_3",
    x1: 167.58,
    y1: 112.39,
    x2: 337.99,
    y2: 112.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04652f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07904f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_3-2",
    y1: 135.37,
    x2: 217.89,
    y2: 135.37,
    xlinkHref: "#_\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_11",
    x1: 167.58,
    y1: 64.75,
    x2: 326,
    y2: 64.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#068c39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#15923b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#23973d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2b9b3e",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e9c3e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m85.67,266.95c3.6-5.47,5.39-12.08,5.39-19.85s-1.8-14.17-5.39-19.78-8.75-9.9-15.46-12.87c-6.71-2.97-14.67-4.46-23.88-4.46H.45v100.68h28.48v-26.75h15.4l18.25,26.75h30.49l-21.73-31.67c6.15-2.89,10.94-6.9,14.33-12.05Zm-27.69-30.56c2.97,2.64,4.46,6.21,4.46,10.71s-1.49,8.34-4.46,10.93c-2.97,2.59-7.43,3.88-13.38,3.88h-15.68v-29.48h15.68c5.94,0,10.4,1.32,13.38,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.1,209.99l-44.44,100.68h29.05l7.91-19.7h42.58l7.91,19.7h29.63l-44.59-100.68h-28.05Zm.89,60.12l12.92-32.19,12.92,32.19h-25.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.66 263.61 243.37 209.99 219.92 209.99 219.92 310.67 247.68 310.67 247.68 257.02 292.12 310.67 315.56 310.67 315.56 209.99 287.66 209.99 287.66 263.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.89 270.11 408.62 270.11 408.62 248.97 363.89 248.97 363.89 232.14 414.66 232.14 414.66 209.99 335.84 209.99 335.84 310.67 416.53 310.67 416.53 288.52 363.89 288.52 363.89 270.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.29,267.02c-2.11-3.5-4.87-6.33-8.27-8.49-3.41-2.16-7.12-3.88-11.15-5.18-4.03-1.29-8.08-2.37-12.15-3.24-4.08-.86-7.79-1.7-11.15-2.52-3.36-.81-6.09-1.87-8.2-3.16-2.11-1.29-3.16-3.09-3.16-5.39,0-1.53.53-2.97,1.58-4.31,1.05-1.34,2.78-2.44,5.18-3.31,2.4-.86,5.56-1.29,9.49-1.29,4.41,0,8.96.62,13.66,1.87,4.7,1.25,9.44,3.21,14.24,5.9l8.63-21c-4.89-2.97-10.52-5.2-16.9-6.69-6.38-1.49-12.87-2.23-19.49-2.23-9.88,0-18.12,1.49-24.74,4.46-6.62,2.97-11.56,6.91-14.81,11.79-3.26,4.89-4.89,10.31-4.89,16.25,0,5.37,1.03,9.83,3.09,13.38,2.06,3.55,4.77,6.43,8.12,8.63,3.36,2.21,7.1,3.98,11.22,5.32s8.17,2.42,12.15,3.24c3.98.82,7.67,1.68,11.07,2.59,3.4.91,6.16,2.01,8.27,3.31,2.11,1.3,3.16,3.05,3.16,5.25,0,1.72-.55,3.21-1.65,4.46s-2.83,2.21-5.18,2.88c-2.35.67-5.54,1.01-9.56,1.01-5.85,0-11.72-.93-17.62-2.8-5.9-1.87-11.1-4.24-15.6-7.12l-9.35,21.14c4.7,3.16,10.86,5.78,18.48,7.84,7.62,2.06,15.6,3.09,23.95,3.09,9.97,0,18.26-1.49,24.88-4.46,6.62-2.97,11.58-6.93,14.89-11.87,3.31-4.94,4.96-10.33,4.96-16.18,0-5.27-1.06-9.66-3.16-13.16Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m148.47,346.1c1.44-1.43,3.14-2.53,5.09-3.3,1.95-.77,4.06-1.16,6.34-1.16s4.19.35,6.06,1.06,3.59,1.85,5.14,3.44l2.55-2.54c-1.66-1.84-3.7-3.22-6.12-4.14-2.42-.92-5-1.38-7.74-1.38s-5.49.48-7.91,1.44-4.52,2.3-6.31,4.03c-1.79,1.73-3.18,3.77-4.17,6.12-.99,2.35-1.49,4.91-1.49,7.69s.5,5.34,1.49,7.69c.99,2.35,2.37,4.39,4.14,6.12s3.86,3.08,6.28,4.03,5.05,1.44,7.91,1.44,5.38-.47,7.8-1.41c2.42-.94,4.46-2.33,6.12-4.17l-2.55-2.54c-1.55,1.59-3.27,2.74-5.14,3.47s-3.9,1.08-6.06,1.08c-2.27,0-4.39-.39-6.34-1.16-1.95-.77-3.65-1.88-5.09-3.3s-2.57-3.09-3.38-4.98c-.81-1.89-1.22-3.98-1.22-6.25s.41-4.36,1.22-6.25c.81-1.9,1.94-3.56,3.38-4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.49,338.38l-17.33,37.9h4.17l4.53-10.13h21.15l4.53,10.13h4.22l-17.33-37.9h-3.95Zm-7.17,24.53l9.12-20.39,9.12,20.39h-18.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.53,339.92c-2.31-1.03-5.07-1.54-8.29-1.54h-14.19v37.9h4.01v-11.97h10.18c3.21,0,5.98-.52,8.29-1.57,2.31-1.05,4.09-2.54,5.33-4.47s1.87-4.23,1.87-6.91-.62-5.08-1.87-7.01-3.02-3.41-5.33-4.44Zm.24,18.41c-1.97,1.64-4.85,2.46-8.64,2.46h-10.07v-18.95h10.07c3.79,0,6.67.83,8.64,2.49s2.95,4.01,2.95,7.04-.98,5.32-2.95,6.96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.39,
    y: 338.38,
    width: 4.01,
    height: 37.9
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.44 338.38 268.79 338.38 268.79 341.85 282.11 341.85 282.11 376.29 286.12 376.29 286.12 341.85 299.44 341.85 299.44 338.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.19,338.38l-17.33,37.9h4.17l4.53-10.13h21.15l4.53,10.13h4.22l-17.33-37.9h-3.95Zm-7.17,24.53l9.12-20.39,9.12,20.39h-18.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.76 372.82 346.76 338.38 342.76 338.38 342.76 376.29 367.99 376.29 367.99 372.82 346.76 372.82"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "225.77 43.32 167.58 45.02 278.95 181.46 337.99 181.46 225.77 43.32"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 167.58,
    y: 89.28,
    width: 50.3,
    height: 92.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m268.59-.49h-101.01v45.51h100.91c9.55,0,17.36,8.78,17.36,19.52v.43c0,10.74-7.81,19.52-17.36,19.52h-100.91s0,45.51,0,45.51h101.01c31.58,0,57.41-29.04,57.41-64.54v-1.41C326,28.55,300.16-.49,268.59-.49Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaneslogo);
export default __webpack_public_path__ + "static/media/raneslogo.52f9b7a36863818923c83554783b2325.svg";
export { ForwardRef as ReactComponent };